import {
  AfterViewInit,
  Component,
  ContentChild,
  ContentChildren,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewContainerRef,
} from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort, SortDirection } from '@angular/material/sort';
import { MatColumnDef, MatTable, MatTableDataSource } from '@angular/material/table';
import { defaultPageSize } from '@platform/shared/utilities/paginator-utility';
import { ExperColumnComponent } from './exper-column.component';
import { SORT_DEFAULT_OPTIONS } from './sort-options-store.service';

@Component({
  selector: 'app-exper-table',
  template: `
    <ng-container>
      <table [attr.id]="tableId" mat-table class="app-table app-table-hoverable" aria-label="Elements">
        <ng-content></ng-content>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="{ 'inactive-item': !rowIsActive(row) }"></tr>
      </table>

      <mat-paginator
        #paginator
        [length]="dataSource.data.length"
        [pageIndex]="initialPage"
        [pageSize]="initialPageSize"
        [pageSizeOptions]="pageSizeOptionsInternal"
        aria-label="Select page"
      ></mat-paginator>
    </ng-container>
  `,
  styles: [
    `
      .full-width-table {
        width: 100%;
        .mat-column-actions {
          width: 10% !important;
        }
      }
    `,
  ],
})
export class ExperTableComponent<T> implements AfterViewInit, OnDestroy {
  @Input() tableId?: string;
  @Input() sampleData: T[] = [];

  // @Input() sortDataFn?: (data: T[], sort: MatSort) => T[];

  @Input() filter?: string;
  @Input() filterPredicateFn?: (item: T, filter: string) => boolean;

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  // @ViewChild(MatSort) sort!: MatSort;
  @ContentChild(MatSort) sort: MatSort;

  @ViewChild(MatTable) table!: MatTable<T>;

  @Input() dataSource: MatTableDataSource<T>;

  // ** sorting
  @Input() initialSortActive?: string;
  @Input() initialSortDirection?: SortDirection;

  @Input() initialPage?: number = 0;
  @Input() initialPageSize?: number = defaultPageSize;

  @Output() matSortChange: EventEmitter<Sort> = new EventEmitter<Sort>();
  @Output() pageChanged: EventEmitter<PageEvent> = new EventEmitter<PageEvent>();

  @Input() pageSizeOptions?: number[];

  @ContentChild('somecont') cont: ViewContainerRef;
  //@ContentChild(MatColumnDef) colDef: MatColumnDef;
  // @ContentChildren(MatColumnDef) colDefsConentChildren: QueryList<MatColumnDef>;

  @ViewChildren(MatColumnDef) colDefs: QueryList<MatColumnDef>;

  //@ViewChildren(ExperColumnComponent) experColumns: QueryList<ExperColumnComponent>;
  //@ViewChild(ExperColumnComponent) experColumn: ExperColumnComponent;

  @ContentChildren(ExperColumnComponent)
  experColumnsCont: QueryList<ExperColumnComponent>; // works
  //@ContentChild(ExperColumnComponent) experColumnCont: ExperColumnComponent;

  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */
  displayedColumns: string[] = [];

  _dataSource: MatTableDataSource<T>;

  constructor() {
    // this.dataSource = new ExperTableDataSource();
    this._dataSource = new MatTableDataSource(this.sampleData);
    // console.log(this._dataSource.data);
  }

  public get pageSizeOptionsInternal(): number[] {
    if (this.pageSizeOptions) {
      return this.pageSizeOptions;
    }
    if (this.dataSource?.data?.length > 50) {
      return [100, 500, 1000, 5000];
    }
    return [50];
  }

  ngOnDestroy(): void {
    this.sort?.sortChange.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.experColumnsCont.forEach((c) => this.table.addColumnDef(c.colDef));
    this.experColumnsCont.forEach((c) => this.displayedColumns.push(c.colDef.name));

    this.sort.disableClear = true;

    this.table.dataSource = this.dataSource;
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;

    const sortState: Sort = {
      active: this.initialSortActive || SORT_DEFAULT_OPTIONS.active,
      direction: this.initialSortDirection || SORT_DEFAULT_OPTIONS.direction,
    };

    this.sort.active = sortState.active;
    this.sort.direction = sortState.direction;

    this.sort.sortChange.emit(sortState);

    if (this.paginator.pageIndex === 0) {
      this.pageChanged.emit({ pageIndex: 0, pageSize: this.paginator.pageSize, length: this.paginator.length });
    }
    this.sort.sortChange.subscribe((sort: Sort) => {
      if (this.matSortChange) {
        this.matSortChange.emit(sort);
      }
    });

    // this.paginator.pageIndex = 0;

    this.paginator.page.subscribe((event) => {
      this.pageChanged.emit(event);
    });
  }

  rowIsActive(row: any) {
    return row.account?.isActive || row.isActive;
  }
}
